"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Client = void 0;
const GetClientDetails_1 = require("./GetClientDetails");
const GetMissingAgreements_1 = require("./GetMissingAgreements");
const PostSaveAgreements_1 = require("./PostSaveAgreements");
const PostEditAddress_1 = require("./PostEditAddress");
const GetHelp_1 = require("./GetHelp");
__exportStar(require("./GetClientDetails"), exports);
__exportStar(require("./GetMissingAgreements"), exports);
__exportStar(require("./PostSaveAgreements"), exports);
__exportStar(require("./PostEditAddress"), exports);
__exportStar(require("./GetHelp"), exports);
exports.Client = {
    GetClientDetails: GetClientDetails_1.GetClientDetails,
    GetMissingAgreements: GetMissingAgreements_1.GetMissingAgreements,
    PostSaveAgreements: PostSaveAgreements_1.PostSaveAgreements,
    PostEditAddress: PostEditAddress_1.PostEditAddress,
    GetHelp: GetHelp_1.GetHelp
};
//# sourceMappingURL=index.js.map